import type { FaireRetailerEntity } from "../../entity_types/retailer";

export const r_464eox2tas: FaireRetailerEntity = {
  token: "r_464eox2tas",
  type: "retailer",
  name: "The Rustic Depot",
  themeTokens: [
    "rustic-depot-farmhouse-charm-wall-kitchen-porch",
    "rustic-depot-cozy-counter-treats-self-care-caramel-popcorn-soap-candles",
    "rustic-depot-minnesota-proud-local-feeling-gifts",
    "rustic-depot-cozy-cabin-candles-jar-rustic-vessels",
    "rustic-depot-small-batch-caramels-chocolate-giftables",
    "rustic-depot-popcorn-wall-bold-flavors-samplers",
    "rustic-depot-cabin-socks-cozy-comfort",
    "rustic-depot-game-night-gifts-board-games-puzzles",
    "rustic-depot-rustic-outdoor-porch-decor",
    "rustic-depot-farmhouse-sayings-shelf-signs",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:42Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
